import React, { useState } from "react";
import axios from "../../axios-backend";
import Line from "../main/Line";
import BackButton from "../main/BackButton";

const AddContent = () => {
  const [content, setContent] = useState("");

  const handleSubmit = async () => {
    try {
      await axios.post("/content", {
        content,
      });

      alert("Content saved successfully");
      setContent("");
    } catch (error) {
      console.log(error);
      alert("Error saving content");
    }
  };

  return (
    <>
    <BackButton />
      <Line type="bottom-line">Add / Update Content</Line>

      <div style={{ padding: "20px", maxWidth: "600px" }}>
        <div>
          <label>Content</label>
          <textarea
            style={{ width: "100%", height: "250px", padding: "8px" }}
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
        </div>

        <button
          style={{ marginTop: "20px", padding: "10px 20px" }}
          onClick={handleSubmit}
        >
          Save Content
        </button>
      </div>
    </>
  );
};

export default AddContent;